import gpt from '@tkww/xo.ads.gpt';
import {waitForUserGeo} from '../utilities/geo';

function callback() {}

async function initializeGPT() {
  // Wait for geolocation to be ready
  const userGeo = await waitForUserGeo();
  const {is_eu: isEU} = userGeo;
  const configPresets = new gpt.configPresets.TheKnotLegacy();
  configPresets.countryCode = isEU ? 'EU' : 'US';
  console.log('[GPT]: Country code set to:', configPresets.countryCode);

  // Per the Ads documentation: This preset configures the adUnit naming convention based on the data in XO.metadata
  gpt.initialize(
    {
      ...configPresets,
      waitUntilUserConsented: true,
      enableLazyLoad: false,
      permutiveConfig: {
        enable: false,
      },
    },
    callback,
  );
}

initializeGPT();
